// @flow
export type Event = {
  category: string,
  action: string,
  label: string,
};

export const getEventCategoryApprovals = (): string => 'MBS Approvals';
export const getEventCategoryAccessories = (): string => 'MBS Accessories';
export const getEventCategoryAccount = (): string => 'MBS Account';
export const getEventCategoryHelp = (): string => 'MBS Help';
export const getEventCategoryProducts = (): string => `MBS`;
export const getEventCategoryCreateProduct = (): string => 'MBS Create Product';
